import React from "react";
import { Image } from "../../../../../components/Image";
import "./style.css";
import { getCaloUserCountLabel } from "../../../../../const/SocialProof";

export const PcUserPower = ({ clickNext = () => {}, clickPrev = () => {}, clicked, isCurPage, }) => {
  return (
    <div className="user-power-pc" data-model-id="16867:12221">

      <div className="contents">
        <div className="title">
          <p className="heading">Calo was made for people just like you!</p>
        </div>

        <div className="div">
          <div className="photo-wall">
            <Image src="/static/image/questionnaire/weight-loss/user-power/pc/photo-wall.png" alt="Photo wall" className="img" />

            <div className="user-count">{getCaloUserCountLabel()}</div>
          </div>

          <div className="user-feedback">
            <p className="feedback-title">
              <span className="text-wrapper">87%</span>

              <span className="span"> of Calo users</span>
            </p>

            <p className="feedback-description">
              report that Calo has helped them achieve long-lasting health
              results. This data comes from users&#39; feedback
            </p>
          </div>
        </div>
      </div>

    </div>
  );
};
